<template>
  <table class="w-100 mb-0" v-if="item">
    <tr>
      <td class="w-25 border-top-0 p-0 align-middle" v-if="isCurrentState">{{ item.lot_no }}</td>
      <td class="border-top-0 p-0 align-middle" :class="isCurrentState ? 'w-75' : 'w-100'">
        <div>
          <b>{{ $t("Status") }}:</b> {{ item.status | removeUnderscores | toUpperCaseFirst }}
        </div>
        <div>
          <b>{{ $t('Hammer') }}:</b>
          {{ hammerPrice | asCurrency(currency ? currency.symbol : null) }}
        </div>
        <div>
          <b>{{ $t('Bidder') }}: </b>
          {{ customerDisplayName }}
        </div>
        <div v-if="isCurrentState">
          <b>{{ $t('Source') }}: </b>
          <span> {{ saleSourceName | removeUnderscores | toUpperCaseEveryWord }}</span>
        </div>
        <div v-if="isCurrentState">
          <b>{{ $t('Approved') }}: </b>
          <span class="badge badge-success" v-if="item.lot.is_result_approved">{{ $t('Yes') }}</span>
          <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "AuctionResultsSyncCellTable",
    props: {
      item: {
        type: Object
      },
      currency: {
        type: Object,
      },
      isCurrentState: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...globalMapState({
        liveAuctionProvider: state => state.liveAuctionProvider
      }),
      currentItem() {
        if (this.isCurrentState) {
          return this.item.lot
        } else {
          return this.item
        }
      },
      hammerPrice() {
        if (!this.currentItem || !this.currentItem.paddle_number) {
          return 'NaN'
        }

        return this.currentItem.hammer_price
      },
      customerDisplayName() {
        if (!this.currentItem || !this.currentItem.paddle_number) {
          return 'NaN'
        }

        if (!this.isCurrentState) {
          let returnVal = this.currentItem.paddle_number
          if (this.currentItem.customer) {
            returnVal = `${returnVal} - ${this.currentItem.customer.display_name}`
          }
          return returnVal
        } else {
          let returnVal = this.currentItem.paddle_number
          if (this.currentItem.bidder && this.currentItem.bidder.customer) {
            returnVal = `${returnVal} - ${this.currentItem.bidder.customer.display_name}`
          }
          return returnVal
        }
      },
      saleSourceName() {
        let source;
        if (this.isCurrentState) {
          source = this.item.lot.source_of_sale
        } else {
          source = this.item.third_party_provider_key
        }

        if (!source) {
          return "NaN"
        }

        if (!this.liveAuctionProvider) {
          return source
        }

        const tmpItem = this.liveAuctionProvider.find(i => i.provider_key === source)

        if (!tmpItem) {
          return source
        }

        return tmpItem.provider_name
      }
    },
    methods: {}
  }
</script>

<style scoped>

</style>